import { configureStore } from "@reduxjs/toolkit";
import { appApi } from "./slices/appApi";
import uiReducer from "./slices/uiSlice";
import builderMessageReducer from "./slices/builderMessageSlice";
// InsertReducerImport
import activeRow from "./slices/ActiveRowState";
import filter from "./slices/FilterState";
import modal from "./slices/ModalState";
import "./slices/databaseSlice";
import "./slices/RoadmapSlice";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    builderMessage: builderMessageReducer,
    // InsertReducerProperty
  activeRow,
  filter,
  modal,
    [appApi.reducerPath]: appApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
